/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { themeV2, linkStyles } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORT : CTA : SIGN IN : STYLES --------------- ++++++++++ */
export default theme => ({
    agreementcopy: {
        maxWidth: pxToEm(400),
        fontWeight: 'normal',
        '& p': {
          color: `${themeV2.color.base.gray.dark} !important`,
        },
        ...linkStyles
    }
});
